import { ActivityAction, ActivityResource } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";

export const ActivityActionOptions = convertMapToOpts(
  ActivityAction,
  ([_, value]) => toTitleCaseString(value)
);

export const ActivityResourceTypeOptions = convertMapToOpts(
  ActivityResource,
  ([_, value]) => toTitleCaseString(value)
);
